/**
 * Ожидание подключения плагина CryptoPro
 */
async function initPlugin(): Promise<any> {
    return new Promise((resolve, reject) => {
        const maxWait = 500000
        let passed = 0

        const interval = setInterval(() => {
            passed += 100

            if (window.cadesplugin) {
                clearInterval(interval)
                resolve(window.cadesplugin)
            }

            if (passed >= maxWait) {
                clearInterval(interval)
                reject(new Error('Плагин КриптоПро недоступен'))
            }
        }, 100)
    })
}

function dateToISO(d: string): string {
    if (!d) return ''

    let parsed = new Date(d)
    if (!isNaN(parsed.getTime())) return parsed.toISOString()

    if (/^\d{14}$/.test(d)) {
        const yyyy = d.slice(0, 4)
        const mm = d.slice(4, 6)
        const dd = d.slice(6, 8)
        const hh = d.slice(8, 10)
        const mi = d.slice(10, 12)
        const ss = d.slice(12, 14)
        return new Date(`${yyyy}-${mm}-${dd}T${hh}:${mi}:${ss}`).toISOString()
    }

    if (/^\d{2}\.\d{2}\.\d{4}/.test(d)) {
        const [date, time = '00:00:00'] = d.split(' ')
        const [dd, mm, yyyy] = date.split('.')
        return new Date(`${yyyy}-${mm}-${dd}T${time}`).toISOString()
    }

    console.warn('Не удалось распарсить дату сертификата:', d)
    return ''
}

/**
 * Преобразование COM certificate → JS объект
 */
async function parseCert(cert: any): Promise<CryptoCert> {
    const from = await cert.ValidFromDate
    const to = await cert.ValidToDate

    return {
        thumbprint: await cert.Thumbprint,
        subject: await cert.SubjectName,
        issuer: await cert.IssuerName,
        validFrom: dateToISO(from),
        validTo: dateToISO(to),
    }
}

export type CryptoCert = {
    thumbprint: string
    subject: string
    issuer: string
    validFrom: string
    validTo: string
}

export class CryptoProService {
    private plugin: any | null = null

    async init() {
        if (this.plugin) return

        this.plugin = await initPlugin()
    }

    async getCertificates(): Promise<CryptoCert[]> {
        await this.init()

        const oStore = await window.cadesplugin.CreateObjectAsync('CAdESCOM.Store')
        await oStore.Open()

        const certs = await oStore.Certificates
        const count = await certs.Count

        const res: CryptoCert[] = []

        for (let i = 1; i <= count; i++) {
            const cert = await certs.Item(i)
            const parsed = await parseCert(cert)
            res.push(parsed)
        }

        await oStore.Close()

        return res
    }
}
